// libs
import React from 'react';
import PropTypes from 'prop-types';

// styles
import './styles.scss';

// proptypes & context
const propTypes = {
  type: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
};

const contextTypes = {
  t: PropTypes.func,
};


function Explication(props) {
  const {
    type,
    content,
  } = props;
  return (
    <div className="explication">
      <span className={`explication__type explication__type--${type}`} />
      <p className="explication__content">{content}</p>
    </div>
  );
}

Explication.propTypes = propTypes;
Explication.contextTypes = contextTypes;

export default Explication;



// WEBPACK FOOTER //
// ./src/app/components/pages/home/parts/explication/Explication.js